import { EXTERNAL_URL } from "~/common/utils/externalURL";

interface AgreeToTermsAndPolicyProps {
  termsUrl: string;
}

export const AgreeToTermsAndPolicy = ({
  termsUrl,
}: AgreeToTermsAndPolicyProps) => {
  return (
    <p className="mt-8 w-full text-center text-sm md:w-1/2">
      By signing in you agree to our <br className="hidden sm:block" />
      <a
        target="_blank"
        rel="noreferrer"
        className="font-semibold underline"
        href={termsUrl}
      >
        Terms & Conditions
      </a>{" "}
      and{" "}
      <a
        target="_blank"
        rel="noreferrer"
        className="font-semibold underline"
        href={EXTERNAL_URL.PRIVACY_POLICY}
      >
        Privacy Policy.
      </a>
    </p>
  );
};
